module.exports = __webpack_public_path__ + "static/media/talleresSD.f489721d.mp4";